import { Component, Vue, } from 'vue-property-decorator';
import ActionIcon from '@/components/action-icon/ActionIcon.vue';

@Component<ActionSaveIcon>({
  components: {
    'action-icon': ActionIcon,
  }
})
export default class ActionSaveIcon extends Vue { }
